exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ml-80[data-v-660c853b]{margin-left:60px}.box-w-70[data-v-660c853b]{width:60px}.detail-box[data-v-660c853b]{border-top-left-radius:2px;border-top-right-radius:0;border-bottom-right-radius:0;border-bottom-left-radius:2px;display:block;float:center;height:200px;width:100%;text-align:center;font-size:45px;line-height:80px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-660c853b","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/buildings/BuildDefinitions.vue
// module id = 367
// module chunks = 0